import { connect } from "react-redux"
import { reduxForm } from "redux-form/immutable"
import withImmutablePropsToJS from "with-immutable-props-to-js"

import { submitRegistration, submitRegistrationSuccess } from "QuorumGrassroots/widgets/action-creators"

import RegistrationForm from "QuorumGrassroots/widgets/LoginRegistration/components/RegistrationForm"
import { RegistrationFormConnection } from "QuorumGrassroots/widgets/LoginRegistration/selectors"
import { withRouter } from "QuorumGrassroots/withRouter"

const submit = (values, dispatch, props) => dispatch(submitRegistration(values, props))

const ReduxRegistrationForm = withRouter(
    reduxForm({
        form: "registration",
        onSubmit: submit,
        onSubmitSuccess: submitRegistrationSuccess,
        touchOnChange: true,
        enableReinitialize: true,
        keepDirtyOnReinitialize: true,
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
    })(RegistrationForm),
)

const ConnectedForm = connect(RegistrationFormConnection, {})(withImmutablePropsToJS(ReduxRegistrationForm))

export default ConnectedForm
